import React, { Fragment } from 'react'
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import NoData from './NoData';

const AssoiciatedTableData = ({ data }) => {
    const styles = StyleSheet.create({
        assoiciatedcontainer: {
            flexDirection: 'row',
            alignItems: 'center',
            fontStyle: 'bold',
            paddingBottom: '5px',
            paddingTop: '10px',
            paddingLeft: '15px',
            border: "1px solid #E4E4E4",
            borderRadius: '5px',
            width: '100%',
            marginTop: '5px',
        },
        report: {
            width: '20%',
            fontSize: "11px",
            color: "#333333"
        },
        date: {
            width: '20%',
            fontSize: "11px",
            color: "#333333"
        },
        recorded: {
            width: '20%',
            fontSize: "11px",
            color: "#333333"
        },
        reference: {
            width: '20%',
            fontSize: "11px",
            color: "#333333"
        },
        amount: {
            width: '20%',
            fontSize: "11px",
            color: "#333333"
        },
    });
    return (
        <Fragment>
            {
                Array.isArray(data?.report) ? (
                    data && data?.report?.length > 0 ?
                        data?.report?.map((items, index) => (

                            <View style={styles.assoiciatedcontainer}>
                                <Text style={styles.report}>{items?.report_number ? items?.report_number : "-"}</Text>
                                <Text style={styles.date}>{items?.submitted_on ? items?.submitted_on : "-"}</Text>
                                <Text style={styles.recorded}>{items?.employee_name ? items?.employee_name : "-"}</Text>
                                <Text style={styles.reference}>{items?.display_status ? items?.display_status : "-"}</Text>
                                <Text style={styles.amount}>{items?.total_amount ? items?.total_amount : "-"}</Text>
                            </View>
                        )) : <NoData title='Assoiciated Reports' />
                ) : (
                    data && data?.report ?
                        (<View style={styles.assoiciatedcontainer}>
                            <Text style={styles.report}>{data?.report?.report_number ? data?.report?.report_number : "-"}</Text>
                            <Text style={styles.date}>{data?.report?.submitted_on ? data?.report?.submitted_on : "-"}</Text>
                            <Text style={styles.recorded}>{data?.report?.employee_name ? data?.report?.employee_name : "-"}</Text>
                            <Text style={styles.reference}>{data?.report?.display_status ? data?.report?.display_status : "-"}</Text>
                            <Text style={styles.amount}>{data?.report?.total_amount ? data?.report?.total_amount : "-"}</Text>
                        </View>)
                        : <NoData title='Assoiciated Reports' />
                )

            }
        </Fragment>
    )
}

export default AssoiciatedTableData;